(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-model-comparison"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-product-model-comparison]');

    sections.forEach((section) => {
      const sectionId = section.dataset.sectionId;
      const dataScript = document.querySelector(`[data-product-model-comparison-data="${sectionId}"]`);

      if (!dataScript) {
        return;
      }

      let models = [];

      try {
        models = JSON.parse(dataScript.textContent.trim());
      } catch (error) {
        return;
      }

      if (!models.length) {
        return;
      }

      const getUniqueIndex = (slotIndex) => slotIndex % models.length;

      const updateSlot = (slotIndex, modelIndex) => {
        const model = models[modelIndex];
        const valueElements = section.querySelectorAll(`[data-slot="${slotIndex}"][data-value-index]`);

        valueElements.forEach((element) => {
          const valueIndex = Number(element.dataset.valueIndex);
          element.textContent = model.values[valueIndex] || '-';
        });

        const pictureSlot = section.querySelector(`.pmc-row--picture [data-slot="${slotIndex}"]`);
        const image = pictureSlot ? pictureSlot.querySelector('.pmc-image') : null;

        if (image) {
          if (model.image) {
            image.src = model.image;
            image.alt = model.imageAlt || model.model || '';
            image.hidden = false;
          } else {
            image.removeAttribute('src');
            image.alt = '';
            image.hidden = true;
          }
        }

        const button = section.querySelector(`.pmc-row--shop [data-slot="${slotIndex}"] .pmc-button`);

        if (button) {
          button.href = model.url || '#';
          button.textContent = model.buttonText || 'Shop now';
        }
      };

      const selects = section.querySelectorAll('.pmc-select');

      selects.forEach((select, slotIndex) => {
        models.forEach((model, modelIndex) => {
          const option = document.createElement('option');
          option.value = String(modelIndex);
          option.textContent = model.model || `Model ${modelIndex + 1}`;
          select.append(option);
        });

        select.value = String(getUniqueIndex(slotIndex));
        updateSlot(slotIndex, Number(select.value));

        select.addEventListener('change', () => {
          updateSlot(slotIndex, Number(select.value));
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
